"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index"));

var _Button = _interopRequireDefault(require("../Button"));

var _Alert = _interopRequireDefault(require("../Alert"));

var _component = require("../component");

var _styles = require("../styles");

var _proptypes = require("../utils/proptypes");

var _locale = require("../locale");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Confirm =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Confirm, _Component);

  function Confirm(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      ok: false,
      cancel: false
    };
    _this.handleCancel = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'cancel');
    _this.handleOk = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)), 'ok');
    return _this;
  }

  var _proto = Confirm.prototype;

  _proto.handleClick = function handleClick(type, close) {
    var _this2 = this;

    var _this$props = this.props,
        onOk = _this$props.onOk,
        onCancel = _this$props.onCancel;
    var fn = type === 'ok' ? onOk : onCancel;
    var callback;
    if (fn) callback = fn();

    if (callback && typeof callback.then === 'function') {
      var _this$setState;

      this.setState((_this$setState = {}, _this$setState[type] = true, _this$setState), function () {
        callback.then(function () {
          var _this2$setState;

          close();

          _this2.setState((_this2$setState = {}, _this2$setState[type] = false, _this2$setState));
        });
      });
    } else {
      close();
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        text = _this$props2.text,
        onOk = _this$props2.onOk,
        okType = _this$props2.okType,
        onCancel = _this$props2.onCancel,
        other = _objectWithoutPropertiesLoose(_this$props2, ["children", "type", "text", "onOk", "okType", "onCancel"]);

    var _this$state = this.state,
        ok = _this$state.ok,
        cancel = _this$state.cancel;
    return _react.default.createElement(_index.default, _extends({}, other, {
      trigger: "click"
    }), function (close) {
      return _react.default.createElement("div", {
        className: (0, _styles.popoverClass)('confirm')
      }, _react.default.createElement("div", {
        className: (0, _styles.popoverClass)('mention')
      }, _react.default.createElement(_Alert.default, {
        type: type,
        icon: true,
        className: (0, _styles.popoverClass)('alert')
      }, children)), _react.default.createElement("div", {
        className: (0, _styles.popoverClass)('footer')
      }, _react.default.createElement(_Button.default, {
        loading: cancel,
        size: "small",
        onClick: function onClick() {
          return _this3.handleCancel(close);
        }
      }, (0, _locale.getLocale)('cancel', text)), _react.default.createElement(_Button.default, {
        loading: ok,
        size: "small",
        type: okType,
        onClick: function onClick() {
          return _this3.handleOk(close);
        }
      }, (0, _locale.getLocale)('ok', text))));
    });
  };

  return Confirm;
}(_component.Component);

exports.default = Confirm;
Confirm.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default, 'type'), {
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  text: _propTypes.default.object,
  onOk: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  okType: _propTypes.default.string
});
Confirm.defaultProps = {
  type: 'warning',
  okType: 'primary'
};